module.exports = __webpack_public_path__ + "img/logo_project_new.4cf11650.png";